module.exports = __webpack_public_path__ + "static/img/chanping6.4630cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp/chanping6.jpg
// module id = EaxA
// module chunks = 0